import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { hideModal, pushModal, replaceModal } from 'redux/modules/modal';
import { subtierSelector } from 'redux/modules/pricing';
import { PlanCancellationReason } from 'types';
import { isProSubTier } from 'utils/pricing';
import { Props } from './types';

export default (props: Props) => {
  const { reason } = props;
  const dispatch = useDispatch();
  const subtier = useSelector(subtierSelector);

  const closeModal = useCallback(() => {
    dispatch(hideModal());
  }, [dispatch]);

  const handleSubmit = useCallback(
    (details: string) => {
      if (
        isProSubTier(subtier) &&
        reason === PlanCancellationReason.DONT_RUN_OUT_OF_VIDEOS
      ) {
        dispatch(
          replaceModal({
            name: 'DowngradeUpsellModal',
            params: { details, reason },
          }),
        );
      } else {
        dispatch(
          replaceModal({
            name: 'CancellationLossAversion',
            params: { details, reason },
          }),
        );
      }
    },
    [dispatch, reason, subtier],
  );

  const onBack = () => {
    closeModal();
    dispatch(
      pushModal({
        name: 'CancelReason',
        params: { reason },
      }),
    );
  };

  return { onSubmit: handleSubmit, onBack };
};
